import {
  FileCheck2,
  ClipboardList,
  ShieldCheck,
  Package,
  Users,
  CheckCircle2,
} from "lucide-react";

export const CACHE_TTL_MS = 5 * 60 * 1000;

export const CACHE_KEYS = {
  employees: "dashboard_employees",
  assets: "dashboard_assets",
  leaves: "dashboard_leaves",
  onboarding: "dashboard_onboarding",
};

export const DEPARTMENTS = [
  "Engineering",
  "Sales",
  "HR",
  "Finance",
  "Marketing",
  "Operations",
  "Support",
  "Legal",
];

export const LIFECYCLE_STATUSES = [
  "Joined",
  "Confirmed",
  "Probation",
  "Notice Period",
  "Resigned",
  "Terminated",
  "Retired",
];

export const ASSET_STATUSES = [
  "Assigned",
  "Available",
  "Under Repair",
  "Disposed",
  "Lost",
];

export const ASSET_CATEGORIES = [
  "Laptop",
  "Desktop",
  "Access Card",
  "Keyboard",
  "Mouse",
  "Monitor",
  "Headset",
  "Phone",
  "Dock",
  "Printer",
  "Others",
];

export const LEAVE_STATUSES = [
  "Approved",
  "Pending",
  "Rejected",
  "Cancelled",
  "Expired",
];

export const ONBOARDING_STAGES = [
  "Offer Accepted",
  "Documents Submitted",
  "Background Verification",
  "Assets Assigned",
  "Orientation",
  "Completed",
];

export const LIFECYCLE_COLORS = {
  Joined: "#3B82F6",
  Confirmed: "#10B981",
  Probation: "#F59E0B",
  "Notice Period": "#8B5CF6",
  Resigned: "#EF4444",
  Terminated: "#7F1D1D",
  Retired: "#9CA3AF",
};

export const LEAVE_COLORS = {
  Approved: "#10B981",
  Pending: "#F59E0B",
  Rejected: "#EF4444",
  Cancelled: "#8B5CF6",
  Expired: "#9CA3AF",
};

export const ASSET_STATUS_COLORS = {
  Assigned: "#3B82F6",
  Available: "#10B981",
  "Under Repair": "#F59E0B",
  Disposed: "#EF4444",
  Lost: "#8B5CF6",
};

export const CATEGORY_COLORS = [
  "#3B82F6",
  "#10B981",
  "#F59E0B",
  "#8B5CF6",
  "#EF4444",
  "#06B6D4",
  "#EC4899",
  "#84CC16",
  "#F97316",
  "#6366F1",
  "#9CA3AF",
];

export const ONBOARDING_ICONS = {
  "Offer Accepted": FileCheck2,
  "Documents Submitted": ClipboardList,
  "Background Verification": ShieldCheck,
  "Assets Assigned": Package,
  Orientation: Users,
  Completed: CheckCircle2,
};

export const ONBOARDING_BAR_COLOR = "#F59E0B";
export const ONBOARDING_DONE_COLOR = "#10B981";

export const GROWTH_OPTIONS = [
  { value: "LAST_MONTH", label: "Last Month" },
  { value: "3_MONTHS", label: "Last 3 Months" },
  { value: "6_MONTHS", label: "Last 6 Months" },
  { value: "LAST_YEAR", label: "Last Year" },
];